import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { EnrollmentNew } from '../../models/enrollment-new.model';
import { EnrollmentService } from '../../services/enrollment.service';

@Component({
    selector: 'app-enrollment-edit',
    templateUrl: './enrollment-edit.component.html',
    styleUrls: ['./enrollment-edit.component.scss']
})
export class EnrollmentEditComponent implements OnInit {

    public steps: MenuItem[] = [

        { label: 'Campus'                 },
        { label: 'Cursos'                 },
        { label: 'Descuentos'             },
        { label: 'Política de privacidad' },
        { label: 'Autorizaciones'         },
        { label: 'Resumen'                },
        { label: 'Confirmación'           }

    ];

    public activeIndex   : number = 0;
    public enrollment    : EnrollmentNew = new EnrollmentNew();
    public isCompleteStep: boolean = false;

    public isProcessing : boolean = false;
    public processResult: { state: string, result: string, message: string } = { state: null, result: null, message: null };

    constructor(private enrollmentService: EnrollmentService, private router: Router) { }

    ngOnInit () { }

    public onActiveIndexChange(event: number) {

        this.activeIndex = event;

    }

    public stepButtonClickEvent(stepEvent: 'next' | 'previous') {

        if (stepEvent === 'next') {
            this.onActiveIndexChange(this.activeIndex + 1);
        }

        if (stepEvent === 'previous') {
            this.onActiveIndexChange(this.activeIndex - 1);
        }

    }

    public postEnrollment() {

        this.isProcessing = true;

        let request = EnrollmentNew.mapToApiRequest(this.enrollment);
        this.enrollmentService.post(request).subscribe({

            next: (response: any) => {

                this.processResult.state   = 'OK';
                this.processResult.result  = response.result;
                this.processResult.message = response.statusError.message;
                this.enrollment.code       = response.result;

            },

            error: (error: any) => {

                this.processResult.state  = 'KO';
                this.processResult.result = error;

            }

        }).add(() => {

            this.isProcessing = false;
            this.stepButtonClickEvent('next');

        });

    }

    public goToEnrollments() {

        let url = `/inscripciones`;
        this.router.navigate([url]);

    }

}
